var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLifeEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H27.2C31.6804 0 33.9206 0 35.6319 0.871948C37.1372 1.63893 38.3611 2.86278 39.1281 4.36808C40 6.07937 40 8.31958 40 12.8V27.2C40 31.6804 40 33.9206 39.1281 35.6319C38.3611 37.1372 37.1372 38.3611 35.6319 39.1281C33.9206 40 31.6804 40 27.2 40H12.8C8.31958 40 6.07937 40 4.36808 39.1281C2.86278 38.3611 1.63893 37.1372 0.871948 35.6319C0 33.9206 0 31.6804 0 27.2V12.8Z",
    className: "backgroundHighlight"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7413 10.6757C19.8409 10.4414 20.1581 10.4414 20.2577 10.6757L21.4951 13.586C21.5362 13.6826 21.6233 13.749 21.7236 13.7601L24.7461 14.0945C24.9894 14.1215 25.0875 14.4377 24.9057 14.6094L22.648 16.7426C22.573 16.8134 22.5397 16.9207 22.5607 17.0242L23.1913 20.1413C23.2421 20.3922 22.9854 20.5877 22.7735 20.4595L20.1408 18.8675C20.0533 18.8147 19.9457 18.8147 19.8583 18.8675L17.2255 20.4595C17.0136 20.5877 16.757 20.3922 16.8077 20.1413L17.4383 17.0242C17.4593 16.9207 17.426 16.8134 17.351 16.7426L15.0933 14.6094C14.9116 14.4377 15.0096 14.1215 15.2529 14.0945L18.2754 13.7601C18.3757 13.749 18.4628 13.6826 18.5039 13.586L19.7413 10.6757Z",
    className: "textCallout"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7H26C27.6569 7 29 8.34315 29 10V22C29 23.6569 27.6569 25 26 25H21.6665L20.2945 26.372C20.1317 26.5347 19.8679 26.5347 19.7052 26.372L18.3332 25H14C12.3431 25 11 23.6569 11 22V10C11 8.34315 12.3431 7 14 7ZM14 9C13.4477 9 13 9.44772 13 10V22C13 22.5523 13.4477 23 14 23H26C26.5523 23 27 22.5523 27 22V10C27 9.44772 26.5523 9 26 9H14Z",
    className: "textCallout"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 32C7.99951 31.4477 8.44723 31 8.99951 31H18.9995V29C18.9995 28.4477 19.4472 28 19.9995 28C20.5518 28 20.9995 28.4477 20.9995 29V31H30.9995C31.5518 31 31.9995 31.4477 31.9995 32C31.9995 32.5522 31.5518 33 30.9995 33H8.99951C8.44723 33 7.99951 32.5522 7.99951 32Z",
    className: "textCallout"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeEvents);
export default __webpack_public_path__ + "static/media/life-events.e1178e6c3ff64eafc612a3ccc24bf98a.svg";
export { ForwardRef as ReactComponent };